function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M44.5 21a5.5 5.5 0 11-4.9 8h-.91c-5.39.06-7.29 1.7-10.31 7.34l-.17.33-.2.38c-1.8 3.37-2.82 4.9-4.66 6.52C20.76 45.84 17.42 47 13 47h-.6a5.5 5.5 0 110-5h.91c5.49-.06 7.36-1.76 10.48-7.67L24 34a27.18 27.18 0 013.11-5H12.4a5.5 5.5 0 110-5h27.2a5.53 5.53 0 014.68-3zm0-19a5.5 5.5 0 11-4.9 8H12.4a5.5 5.5 0 110-5h27.2a5.5 5.5 0 014.9-3z"
});

var SvgIntegration = function SvgIntegration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    fill: "#9193A9",
    viewBox: "0 0 52 52"
  }, props), _ref);
};

export default SvgIntegration;